import { Component, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { Order } from 'src/app/models/order';
import { Router } from '@angular/router';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  public orders: Order[];
  public loadingOrders: boolean = true;
  constructor(private orderService: OrderService, private router: Router) { }

  ngOnInit() {
    this.orderService.getOrders().subscribe(orders=>{
      this.orders = this._filterOrders(orders);
      this.loadingOrders = false;
    })
  }

  _filterOrders(orders) {
    let filteredOrders = new Array();
    orders.forEach((order) => {

      if(order.status != 'Pending') filteredOrders.push(order);
    
    });

    return filteredOrders;
  }


  goToOrder(order_id){
    this.router.navigate([`/account/orders/${order_id}`]);
  }

}
